import Image from "next/image";
import { ButtonLink } from "@/components/ui/button";
import CustomIcon from "@/components/ui/custom-icon";
import { useHomeData } from "../../hooks/useHomeData";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import { useMedia } from "@/hooks/system/useMedia";

const CatalogSection = () => {
  const { home } = useHomeData();
  const { isClient } = useMedia();

  return home?.banner?.map(item => (
    <Container className={S.wrapper} key={item.title}>
      <Image
        src={item.bg}
        alt={item.title ?? ""}
        width={1600}
        height={720}
        style={{ objectFit: "contain", height: "auto" }}
      />
      <div className={S.content}>
        {isClient && (
          <div className={S.textWrapper}>
            <h2 className={S.title} dangerouslySetInnerHTML={{ __html: item.title }} />
            <p className={S.desc} dangerouslySetInnerHTML={{ __html: item.description }} />
          </div>
        )}
        {item.button.link && (
          <ButtonLink variant="white" href={item.button.link} target="_blank">
            {item.button?.title}
            <CustomIcon fileName="arrow-down-icon" />
          </ButtonLink>
        )}
      </div>
    </Container>
  ));
};

export default CatalogSection;
